import * as React from 'react';
import { attachWrappedComponent } from '../../utils/decoratorUtils/decoratorUtils';
import { requestIdleCallback, cancelIdleCallback } from '../../utils/Timers';
export default function (Component) {
  class MeasureInputDecorator extends React.Component {
    constructor(props) {
      super(props);
      this.measureInput = () => {
        if (!this._isMounted) return;
        const inputNode = this.props.inputRef.current;
        if (inputNode) {
          const inputWidth = inputNode.offsetWidth;
          if (inputWidth !== this.state.inputWidth) {
            this.setState({
              inputWidth
            });
          }
        }
      };
      this.handleWindowResize = () => {
        cancelIdleCallback(this._resizeTimer);
        this._resizeTimer = requestIdleCallback(this.measureInput);
      };
      this.state = {
        inputWidth: null
      };
      this._isMounted = false;
      this._resizeTimer = null;
    }
    componentDidMount() {
      this._isMounted = true;
      window.addEventListener('resize', this.handleWindowResize);
      this.measureInput();
    }
    componentDidUpdate(prevProps, prevState) {
      if (prevState.inputWidth === this.state.inputWidth) {
        this.measureInput();
      }
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
      cancelIdleCallback(this._resizeTimer);
      this._isMounted = false;
    }
    render() {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, this.props, {
        inputWidth: this.state.inputWidth
      }));
    }
  }
  attachWrappedComponent(MeasureInputDecorator, Component);
  return MeasureInputDecorator;
}